import { BROWSER_PROMPT_OPTIONS, DEFAULT_BROWSER_PROMPT_VERSION } from '../constants/bookingConst';

/**
 * The Open in Browser popup option (Config -> Theme -> Open in Browser Popup)
 * for a stored value, falling back to the default popup for a missing or
 * unknown value — a config saved before the setting existed, or a version
 * since retired.
 *
 * @param {string|undefined|null} value - config.browserPromptVersion
 * @returns {{value: string, label: string, description: string}}
 */
export const resolveBrowserPromptOption = (value) => (
  BROWSER_PROMPT_OPTIONS.find(option => option.value === value)
  || BROWSER_PROMPT_OPTIONS.find(option => option.value === DEFAULT_BROWSER_PROMPT_VERSION)
);

/**
 * "Version 1" / "Version 2" for a stored value, for the audit trail.
 *
 * @param {string|undefined|null} value - config.browserPromptVersion
 * @returns {string}
 */
export const getBrowserPromptLabel = (value) => resolveBrowserPromptOption(value).label;
